import * as React from 'react';
import { useState } from 'react';
import Select from 'react-select';
import { Col, Container, Label, Row } from 'reactstrap';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { Account, Afr, createAccount, DimensionReference, Fact, FactTableRow, getRow, getRowIdForAccountAndDimensions, getSelectedAfr, getTable, NewAccount, TableBreakdownEntry } from '../../../redux/AfrSlice';
import { AccountRangeFilter } from '../../../utils/utilityHelper';
import Modal from './Modal';
import './ModalPopUp.css';
import { Concept, getPublicName } from '../../../redux/ConceptSlice';



//import { statSync } from 'node:fs';

interface ddSelection {
    dropdown: string,
    dropdowntype:string,
    account: Account | null,
    dimref: DimensionReference | null
}

export function shouldExcludeCode(code: string, filter: AccountRangeFilter): boolean {
    if (!filter) {
        return false;
    }
    if (code < filter.first) {
        return true;
    }
    if (code > filter.last) {
        return true;
    }
    return false;
}


function SelectNewAccountModal(props: any) {

    const dispatch = useAppDispatch();

    const [state, setState] = useState<Array<ddSelection>>([{
        dropdown: "",
        dropdowntype: "",
        account: null,
        dimref: null
    }]);

    const currentAfr: Afr | null = useAppSelector(getSelectedAfr);
    if (!currentAfr) {
        return null;
    }
    const acctTable = getTable(currentAfr, props.tableName);

    const [columnHierarchyMemberIdsFromFundGroup, setColumnHierarchyMemberIdsFromFundGroup] = React.useState<Set<string>>(new Set());

    // Handle Event
    const handleChange = (e: any, action: any) => {

        var ddName: string = action.name;
        var accountCode: string = e.value;
        var axe: number;
        var acct: Account | null = null;
        var dref: DimensionReference | null = null;
        var ddType = "Account";
        var newState = JSON.parse(JSON.stringify(state));
        if (!acctTable) {
            alert("Missing table for selection processing of " + ddName);
        } else {
            if (ddName.includes("acc_")) {
                var c = acctTable.structure.rows.find(acc => acc.code === accountCode);
                if (c) {
                    acct = { name: c.name, code: c.code, id: c.id };
                }
            } else {
                // it is a sub-account
                axe = Number(ddName.split("_")[1]) - 1
                var a = acctTable.structure.rowHierarchy.axes[axe];
                var m = a.membersByYear.find(subacc => subacc.code === accountCode);
                ddType = a.name;
                if (m) {
                    dref = { axis: a, member: m, typedContent: null }
                }
            }
        }

        var index = newState.findIndex((itm: any) => itm.dropdown === ddName);
        var selectedValue = { dropdown: ddName, dropdowntype: ddType, account: acct, dimref: dref }


        if (index === -1) {
            newState.push(selectedValue)
        } else {
            newState[index] = selectedValue
        }
        newState.sort((a: any, b: any) => a.dropdown > b.dropdown ? 1 : -1);

        setState(newState);

    }


    const allowsDuplicateAccounts = (): boolean => {
        if (!acctTable) {
            return false;
        }
        if (!acctTable.structure.rowHierarchy.axes) {
            return false;
        }
        for (var axis of acctTable.structure.rowHierarchy.axes) {
            if (axis.typedDomain) {
                return true;
            }
        }
        return false;
    }
    // browse the and save temporarily in redux store
    const handleAddNewccount = (e: any) => {
        var dims: Array<DimensionReference> = [];
        var acct: any | null = null;
        var existedAcct: any | null = null;

        //Validate that each dropdown is selected
        for (var itm of state) {
            // this conidtion will execute, if account code is already prepopulated using hamburger icon.
            if (props.row && props.row.account && existedAcct == null) {
                existedAcct = { code: props.row.accountCode, id: props.row.accountId, name: props.row.account };
                itm.account = existedAcct;
            }
            if (itm.account) {
                acct = itm.account;
            } else if (itm.dimref) {
                dims.push(itm.dimref as unknown as DimensionReference);
            } else {
                alert(itm.dropdowntype + " are mandatory!")
                return false;
            }
        }
        if (!acct) {
            alert("selection must include an account!")
            return false;
        }
        // saving in AFR slice
        var afrAccount: NewAccount = {
            tableId: props.tableName,
            account: acct,
            dimensions: dims
        }
        if (!acctTable) {
            alert("no account table defined!")
            return false;
        }
        var targetRowId = getRowIdForAccountAndDimensions(acct, dims);
        var dupsAllowed = allowsDuplicateAccounts();

        if (!dupsAllowed) {
            const row = getRow(acctTable, targetRowId);
            if (row) {
                if (props.columnFilter && row && row.account && row.account.code) {
                    let shouldNotAddRow: boolean = accountHasFactsWithFundGroup(row.account.code);
                    if (shouldNotAddRow == true) {
                        alert("Account already exist, please check!");
                        return false;
                    }
                } else {
                    alert("Account already exist, please check!");
                    return false;
                }
            }  
        }


        // Save the information in redux afr
        dispatch(createAccount(afrAccount));

        //close modal
        props.onCloseModal(targetRowId);
        
    }

    function renderSubAccounts(axeLabel : any, axeCode : any, options : any) {

        return (
            <React.Fragment key={axeCode}>

                <Container>
                    <Row xs="1">
                        <Col>
                            <Label ><b>{axeLabel}:</b></Label>
                        </Col>
                    </Row>
                    <Row xs="1">
                        <Col>
                            <Select
                                name={'axe_' + axeCode}
                                onChange={handleChange}
                                options={options}
                                style={{ width: "25em" }}
                            />

                        </Col>
                    </Row>
                    <br />
                    <br />
                </Container>
            </React.Fragment >
        );
    }

    function renderAccounts(options: any, defaultValue: { value: string; label: string; isdisabled: boolean } |undefined=undefined) {

        return (
            <React.Fragment key={'acc_' + props.tableName }>

              <Container>
                    <Row xs="1">
                        <Col>
                            <Label ><b>Accounts:</b></Label>
                        </Col>
                    </Row>
                    <Row xs="1">
                        <Col>
                            <Select
                                name={'acc_' + props.tableName}
                                onChange={handleChange}
                                autoFocus
                                options={options}
                                value={defaultValue}
                                isOptionDisabled={(option: any) => option.isdisabled}
                                style={{ width: "25em" }}
                            />

                        </Col>
                    </Row>
                    <br />
                    <br />
              </Container>
            </React.Fragment >
        );
    }

    const getScopedInfo = function (accCode: string): string {
        var scInfo = "";
        if (props.scopeMappings) {
            if (props.scopeMappings.accountMappings.hasOwnProperty(accCode) && props.scopeMappings.filter.indexOf(accCode) >= 0) {
                // We are a fund group restricted account, check and see if we're in the exclusion filter for this fund group
                scInfo += " (use only for ";
                scInfo += props.scopeMappings.accountMappings[accCode].map((c: Concept) => getPublicName(c)).join(", ");
                scInfo += ")";
            }
        }
        return scInfo;
    }

    const buildColumnHierarchyMemberIds = (): Set<string> => {
        let result: Set<string> = new Set<string>();

        if (props.columnFilter) {

            var accountTableValue = getTable(currentAfr, props.tableName);

            if (accountTableValue && accountTableValue.structure && accountTableValue.structure.nthlevelcolumnHierarchy) {

                //get the member ids of the column hierarchy for this account code.  A column hierarchy has a label and a list of sublevels.  Each sublevel has a dimension and a member id.
                //component units currently don't have any sub levels.  So you have to just take the member id from the column hierarchy itself.
                let fundGroupConceptMemberIds: TableBreakdownEntry[] = accountTableValue.structure.nthlevelcolumnHierarchy.filter((columnHierarchyValue: any) =>
                    columnHierarchyValue.label.toLowerCase() == props.columnFilter.toLowerCase());

                if (fundGroupConceptMemberIds) {

                    result = new Set<string>(
                        fundGroupConceptMemberIds.flatMap((columnHierarchy: TableBreakdownEntry) =>
                            (columnHierarchy.sublevels
                                ? columnHierarchy.sublevels.map((columnLevel: TableBreakdownEntry) => columnLevel.dimensionaspect.member ? columnLevel.dimensionaspect.member.id : null)
                                : [columnHierarchy.dimensionaspect.member ? columnHierarchy.dimensionaspect.member.id : null])
                                .filter((id): id is string => !!id)));

                }
            }
        }

        return result;
    };

    const accountHasFactsWithFundGroup = (accountCode: string): boolean => {

        let result: boolean = false;

        if (acctTable && acctTable.rows) {
            if (props.columnFilter) {
                //get the relating Fact table row for this account code. A Fact table row has an account code and relating fact values.
                const existingFactsForAccount = acctTable.rows.filter((rowMatchingCode: any) => rowMatchingCode.account.code === accountCode);
                if (existingFactsForAccount) {

                    //get the member ids of the existing facts for this account code.  A Fact table row has an account code and relating fact values.  Each fact value has a dimension and a member id.
                    const existingFactsDimensionMemberIds = new Set<string>(
                        existingFactsForAccount.flatMap((existingFactForAccount: FactTableRow) =>
                            existingFactForAccount.facts
                                .map((existingDimensionForFact: Fact) =>
                                    existingDimensionForFact.dimensions[0].member ? existingDimensionForFact.dimensions[0].member.id : null)
                                .filter((id): id is string => !!id)));

                    if (existingFactsDimensionMemberIds.size > 0) {

                        if (columnHierarchyMemberIdsFromFundGroup) {

                            const hasFactsWithFundGroup: boolean = [...existingFactsDimensionMemberIds].some(memberId => columnHierarchyMemberIdsFromFundGroup.has(memberId));
                            return hasFactsWithFundGroup;
                        }
                    }
                }
            }
        }
        
        return result;
    }


    const isDisabled = function (accCode: string): boolean {
        if (!acctTable) {
            return false;
        }
        if (props.scopeMappings && props.scopeMappings.accountMappings.hasOwnProperty(accCode)) {
            // We are a fund group restricted account, check and see if we're in the exclusion filter for this fund group
            if (props.scopeMappings.filter.indexOf(accCode) >= 0) {
                return true;
            }
        }
        if (acctTable.structure.rowHierarchy.axes) {
            return false;
        }
        if (acctTable.rows.findIndex(row => row.account !== null && row.account.code === accCode) === -1) {
            return false;
        }

        if (props.columnFilter) {

            return accountHasFactsWithFundGroup(accCode);
        }

        return true;
    }



    function generateDropdownValues(updateState: boolean) {

        var render : any[] = [];
        var ddState: Array<ddSelection> = [];
        var axe_i: number = 1;

        if (!acctTable
            || !acctTable.structure
            || !acctTable.structure.rows
            || !acctTable.structure.rowHierarchy) {
            render.push(<span></span>);
            return render;
        }
        // Population dropdown for accounts
        const filteredOptions = acctTable.structure.rows.filter(function (acc) {
            var trimmedCode = acc.code.trim().toLowerCase();
            if (trimmedCode === '' || trimmedCode.includes('x') || trimmedCode.includes('-')) {
                return false;
            }
            if (shouldExcludeCode(acc.code, props.filter)) { 
                return false;
            }
            return true;
        })

        const options = filteredOptions.map(opc => ({
            value: opc.code,
            label: opc.name + getScopedInfo(opc.code),
            isdisabled: isDisabled(opc.code)
        }));
        
        options.sort((a, b) => a.value > b.value ? 1 : -1);
        
        var foundOptionValue: { value: string; label: string; isdisabled: boolean }|undefined = undefined;

        if (props.row && props.row.accountCode) {
            foundOptionValue = options.find((element: { value: string; label: string; isdisabled: boolean }) => props.row.accountCode == element.value);
        }
            

        // render accounts
        render.push(renderAccounts(options, foundOptionValue));
        ddState.push({ dropdown: 'acc_' + props.tableName, dropdowntype:"Account", account: null, dimref : null })
        

        if (!acctTable.structure.rowHierarchy.axes) {
            if (updateState) {
                setState(ddState);
            }
            return render;
        }
        for (var axis of acctTable.structure.rowHierarchy.axes) {
            if (axis.typedDomain) {
                if (updateState) {
                    setState(ddState);
                }
                return render;
            }
        }
        // generating sub-accounts
        for (var axe of acctTable.structure.rowHierarchy.axes) {
            const options = axe.membersByYear.map(opc => ({
                value: opc.code,
                label: opc.name
            }));
            var accCode = (state.length > 0 && state[0].account) ? state[0].account.code : "0";
            var restriction: string | null = null;
            switch (accCode) {
                case "517":
                    restriction = "70";
                    break;
                case "518":
                    restriction = "30";
                    break;
                case "581":
                    restriction = "90";
                    break;
                case "587":
                    restriction = "30";
                    break;
            }
            // render sub-accounts
            if (restriction) {
                render.push(renderSubAccounts(axe.name, axe_i, options.filter(x => x.value === restriction)));
            } else {
                render.push(renderSubAccounts(axe.name, axe_i, options));
            }
            ddState.push({ dropdown: 'axe_' + axe_i, dropdowntype: axe.name, account: null, dimref: null })
            axe_i = axe_i + 1;
        }
        if (updateState) {
            setState(ddState);
        }
        return render;

    }

    const renderPage = generateDropdownValues(false)

    React.useEffect(() => {

        const fundGroupMemberIdsFromColumnFilter = buildColumnHierarchyMemberIds();
        setColumnHierarchyMemberIdsFromFundGroup(fundGroupMemberIdsFromColumnFilter);

        generateDropdownValues(true)

    }, [props]);


        
    return (
        <React.Fragment >
            <Modal isOpen={props.isOpen} onClose={props.onCloseModal}>
                <div className="ModalPopUp">
                    <h4>Adding new account</h4>
                    <br />
                    <br />
                    {props.isOpen && renderPage /* generateDropdownValues()*/}


                    <div>
                        <button onClick={handleAddNewccount} className="btn btn-primary mr-4">
                            Add
                        </button>
                        <button onClick={props.onCloseModal} className="btn btn-primary">
                            Cancel
                        </button>
                    </div>
                </div>
            </Modal>
        </React.Fragment >
    );
}

export default SelectNewAccountModal;Modal;